import { Component } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ButtonComponent } from '../../utilities/button/button.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { CustomerService } from '../../services/customer.service';
import { InputComponent } from '../../utilities/input/input.component';
import { TextAreaComponent } from '../../utilities/text-area/text-area.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TableComponent } from "../../components/table/table.component";
import { CommonModule } from '@angular/common';
import { PaginationComponent } from "../../utilities/pagination/pagination.component";
import { Router } from '@angular/router';

@Component({
  selector: 'app-customers',
  standalone: true,
  imports: [
    DashboardComponent,
    ButtonComponent,
    ModalComponent,
    InputComponent,
    TextAreaComponent,
    CommonModule,
    TableComponent,
    PaginationComponent
],
  templateUrl: './customers.component.html',
  styleUrl: './customers.component.scss',
})
export class CustomersComponent {
  createModalOpen: boolean = false;
  viewModalOpen: boolean = false;
  fetchingData: boolean = false;
  singleCustomer: any;
  customerId: string = '9389djeueeduded14';
  customers: any;
  loading: boolean = false;
  filterData: Array<any> = [];
  fromDate: any;
  toDate: any;
  page: number = 1;
  limit: number =  25;
  totalCustomers: any;
  newCustomer: any = {
    userIdentifier: '',
    emailAddress: '',
    phoneNumber: '',
    fullName: '',
    metaData: { data: '' },
  };
  emptyTableState = {
    title: 'No data found',
    label: 'You have no active customers',
    // action: () => { }
  };
  errors: any = {
    userIdentifier: '',
    emailAddress: '',
    phoneNumber: '',
    fullName: '',
    metaData: { data: '' },
  };
  columnWidths = ['20%', '20%', '20%', '20%', '20%'];
  tableHeader: any;
  tableData: any[] = [];
  constructor(private customerService: CustomerService,  private notification: NzNotificationService, private router: Router) {
    this.getCustomers();
    this.fromDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    this.toDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    );
    this.filterData = [
      {
        type: 'date-range',
        name: 'date-range',
        label: 'Date Range',
        fromDate: this.fromDate,
        toDate: this.toDate,
        fromDateValue: '',
        toDateValue: '',
      },
      {
        type: 'select',
        name: 'channel',
        label: 'Channel',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'wallet', value: 'Wallet' },
          { key: 'card', value: 'Card' },
          { key: 'ussd', value: 'Ussd' },
          { key: 'loyaltyCard', value: 'Loyalty Card' },
          { key: 'onlineTransfer', value: 'Online Transfer' },
        ],
      },
      {
        type: 'select',
        name: 'tansaction-type',
        label: 'Transaction Type',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'funding', value: 'Funding' },
          { key: 'withdrawal', value: 'Withdraw' },
        ],
      },
      {
        type: 'select',
        name: 'tansaction-status',
        label: 'Transaction Status',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'failed', value: 'Failed' },
          { key: 'success', value: 'Success' },
          { key: 'pending', value: 'Pending' },
        ],
      },
      {
        type: 'select',
        name: 'transaction-initiator',
        label: 'Transaction Initiator',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'company', value: 'Company' },
          { key: 'customer', value: 'Customer' },
        ],
      },
    ];
  }
  openCreateModal = () => {
    this.createModalOpen = true;
  };
  closeCreateModal = () => {
    this.createModalOpen = false;
  };
  openViewModal = () => {
    this.viewModalOpen = true;
  };
  closeViewModal = () => {
    this.viewModalOpen = false;
  };
  formatDate(date: string){
    const dateTimeString = date;
    const dateTime = new Date(dateTimeString);
     return dateTime.toLocaleString();
   }
  handleInput(data: { title: string; value: string }) {
    this.newCustomer[data.title] = data.value;
    if (data.value === '') {
      this.errors[data.title] = 'Required*';
      return;
    } else {
      this.errors[data.title] = '';
    }
  }
  validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  validateForm = () => {
    const errors: any = {};
    if (this.newCustomer.name === '') {
      errors.fullName = 'Required*';
    }
    if (this.newCustomer.userIdentifier === '') {
      errors.userIdentifier = 'Required*';
    }
    if (this.newCustomer.phoneNumber === '') {
      errors.phoneNumber = 'Required*';
    }
    if (this.newCustomer.emailAddress === '') {
      errors.emailAddress = 'Required*';
    } else if (!this.validateEmail(this.newCustomer.emailAddress)) {
      errors.emailAddress = 'Please use a valid email*';
    }
    // console.log(errors);
    return errors;
  };
  getCustomers() {
    this.fetchingData = true;
    this.customerService.getCustomers().subscribe({
      next: (res: any) => {
        console.log(res);
        this.customers = res.data.result;
        this.singleCustomer = res.data;
        this.totalCustomers = res.data.count;
        this.fetchingData = false;
        this.tableHeader = [
          { name: 'Full Name', ratio: { width: '33%', minWidth: '204px' } },
          { name: 'Email', ratio: { width: '33%', minWidth: '83px' } },
          { name: 'Phone Number', ratio: { width: '33%', minWidth: '83px' } },
        ];
        this.tableData = this.customers.map(
          (customer: any, n: number) => {
            // console.log('tlocation', transaction.transactionCharges);
            // await this.getLocationBalance(this.locations[n].hasOwnProperty('sales_point_account'), n)
            return [
              {
                name: {
                  title: customer.fullName,
                  label: this.formatDate(customer.createdAt),
                },
                ratio: { width: '33%', minWidth: '180px' },
                id: customer._id,
              },
              {
                name: {
                  title: `<span>${customer.emailAddress}</span>`,
                },
                ratio: { width: '33%', minWidth: '50px' },
                id: customer._id,
              },
              {
                name: {
                  title: `<span>${customer.phoneNumber}</span>`,
                },
                ratio: { width: '33%', minWidth: '50px' },
                id: customer._id,
              },
            ];
          }
        );
      },
      error: (err) => {
        this.fetchingData = false;
      },
    });
  }
  createCustomer() {
    if (Object.keys(this.validateForm()).length > 0) {
      this.errors = { ...this.errors, ...this.validateForm() };
    } else {
      this.loading = true;
      this.customerService.createCustomer(this.newCustomer).subscribe({
        next: (res: any) => {
          // this.getBusinesses();
          console.log(res);
          this.loading = false;
          this.createModalOpen = false;
          this.notification.success('Success', 'Customer created successfully', {
            nzClass: 'notification',
          });
        },
        error: (err) => {
          this.loading = false;
          this.notification.error('Error', 'Failed to create customer', {
            nzClass: 'notification',
          });
        },
      });
    }
  }
  navigateTo(data: any){
    this.router.navigate([`/customer-details/${data}`]);
  }
  changeLimit(data: any){}
  applyFilter(data: any){}
  search(data: any){}
  refreshList(){}
}
